import React, { Component } from 'react'
import { useEffect, useState } from 'react';

import { Message, Sticky } from 'semantic-ui-react'

const MessageAlert = ({msg}) =>  {
  
  const [visible, setVisible] = useState(true);
  
  const handleDismiss = () => { setVisible(false) }

  if(msg.autoClose){
    setTimeout(() => { setVisible(false) }, msg.autoCloseTime || 10000)
  }

  return(
    visible 
    &&    
    <div className="puzzel-message-alert">
      <Message
        floating
        info={msg.type === 'info' ? true : false}
        warning={msg.type === 'warning' ? true : false}
        error={msg.type === 'error' ? true : false}
        
        size={'small'}
        onDismiss={handleDismiss}
        header={msg.header}
        content={msg.content}
      />
    </div>
  )
}

export default MessageAlert
